<script>
import isEmpty from 'lodash/isEmpty'
export default {
  props: {
    adornment: {
      type: String,
      default: '',
      require: false,
    },
    clickAdornment: {
      type: Function,
      require: true,
      default: () => {},
    },
    veeName: {
      type: String,
      require: false,
      default: '',
    },
    rows: {
      type: Number,
      require: false,
      default: null,
    },
    /**
     * rules vee-validate https://vee-validate.logaretm.com/v2/guide/rules.html
     */
    rules: {
      type: Object,
      require: false,
      default: () => {},
    },
  },
  data() {
    return {
      invalid: false,
    }
  },
  computed: {
    isValidate() {
      if (this.rules && !isEmpty(this.rules) && !this.invalid) {
        return 'is-valid'
      }
      return ''
    },
    rulesComputed() {
      if (this.rules) {
        return this.rules
      }
      return {}
    },
  },
  methods: {
    clickIconAdornment() {
      this.$emit('clickAdornment')
    },
    getValidationState({ dirty, validated, valid = null }) {
      this.invalid = dirty || validated ? valid : null
      return dirty || validated ? valid : null
    },
  },
}
</script>

<template>
  <validation-provider
    v-slot="validationContext"
    :rules="rulesComputed"
    :name="veeName"
  >
    <div id="feelline-base-textarea" class="position-relative">
      <CTextarea
        ref="textarea"
        v-bind="$attrs"
        :[isValidate]="getValidationState(validationContext)"
        :invalid-feedback="validationContext.errors[0]"
        :class="{ positionBg: adornment }"
        :rows="rows"
        v-on="$listeners"
      >
        <template
          v-for="slot in [
            'prepend',
            'append',
            'prepend-content',
            'append-content',
            'label',
            'label-after-input',
            'valid-feedback',
            'invalid-feedback',
            'description',
          ]"
          v-slot:[slot]
        >
          <slot :name="slot"></slot>
        </template>
      </CTextarea>
      <font-awesome-icon
        v-if="adornment"
        :icon="adornment"
        class="custom-adorment"
        @click="clickIconAdornment"
      />
    </div>
  </validation-provider>
</template>

<style lang="scss" scoped>
#feelline-base-textarea {
  .positionBg {
    ::v-deep .is-invalid {
      background-position: right calc(0.375em + 2rem) center;
    }
  }

  ::v-deep textarea {
    min-height: 80px;
  }

  ::v-deep .form-control-plaintext {
    outline: none;
  }

  ::v-deep .custom-adorment {
    position: absolute;
    top: 11px;
    right: 12px;
    z-index: 4;
    cursor: pointer;
  }
}
</style>
